import { render, staticRenderFns } from "./goods-popup.vue?vue&type=template&id=17471413&scoped=true&lang=pug&"
import script from "./goods-popup.vue?vue&type=script&lang=js&"
export * from "./goods-popup.vue?vue&type=script&lang=js&"
import style0 from "./goods-popup.vue?vue&type=style&index=0&id=17471413&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17471413",
  null
  
)

export default component.exports